/** @format */

import Vue from 'vue';
export const notificationBus = new Vue();
